import React, { useContext } from "react";
import { Card, CardMedia, useTheme } from "@mui/material";
import BannerContext from "../contexts/BannerContext";
import cabezalEnBlanco from "./cabezalEnBlanco.jpg";

function Banner() {
  const theme = useTheme();
  const { bannerUrl, bannerStatus } = useContext(BannerContext);

  // En teoría App.js bloquea el render hasta que esté listo,
  // pero por seguridad si llegara "loading" no mostramos nada.
  if (bannerStatus === "loading") return null;

  return (
    <Card
      sx={{
        maxWidth: "100%",
        position: "relative",
        margin: "0 auto",
        borderRadius: 0,
      }}
    >
      <CardMedia
        component="img"
        src={bannerUrl || cabezalEnBlanco}
        alt="Banner hotel"
        sx={{
          width: "100%",
          height: 140,
          objectFit: "cover",
          [theme.breakpoints.up("sm")]: {
            height: 200,
          },
        }}
      />
    </Card>
  );
}

export default Banner;
